import * as React from 'react';
import { FilteredMainMarkets, MatchListStoreModel } from '../utils/match-list-models';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import {
    marketsIdsToDisplayOddsParamBetweenOdds,
    marketsIdsToDisplayOddsParamFor,
    MATCH_LIST_BEM as bem,
} from '../utils/match-list.constants';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import getSlice from '@om-fe/core/utils/get-slice';

export interface OutcomeListStoreProps {
    readonly filteredMainMarket?: FilteredMainMarkets;
}

export interface OutcomeListPublicProps {
    readonly sliceKey: string;
    readonly mainMarketId: string;
    readonly children?: React.ReactNode;
}

export type OutcomeListProps = OutcomeListPublicProps
    & OutcomeListStoreProps
    & I18nContextInterface;

class OutcomeListComponent extends React.PureComponent<OutcomeListProps> {
    render(): React.ReactNode {
        const { filteredMainMarket, children } = this.props;

        if (!filteredMainMarket) {
            return null;
        }

        const { bettingTypeId, bettingTypeName, id, eventPartId, numberOfOutcomes, translatedName, eventPartName, hasSelector } = filteredMainMarket;
        const keyName: string = `market-${id}`;
        
        return (
            <div
                className={bem('OutcomeWrapper', {
                    [`Column-${numberOfOutcomes}`]: true,
                    [`BettingType-${bettingTypeId}`]: true,
                    [`EventPart-${eventPartId}`]: true,
                    HasParameterInside: marketsIdsToDisplayOddsParamFor.includes(bettingTypeId),
                    HasParameterOutside: marketsIdsToDisplayOddsParamBetweenOdds.includes(bettingTypeId),
                })}
                key={keyName}
            >
                {
                    children 
                    ?? (
                        hasSelector 
                        ? <span className={bem('MarketBetType')}>{translatedName}</span>
                        : <>
                            <span className={bem('MarketBetType')}>{bettingTypeName}</span>
                            <span className={bem('MarketEventPart')}>{eventPartName}</span>
                        </>
                    )
                    
                }
            </div>
        );
    }
}

const OutcomeList: React.ComponentType<OutcomeListPublicProps> = compose<React.ComponentType<OutcomeListPublicProps>>(
    connect<OutcomeListStoreProps>(
        (state: AppState, props: OutcomeListPublicProps): OutcomeListStoreProps => {
            const { sliceKey, mainMarketId } = props;
            const slice: MatchListStoreModel | undefined = getSlice<MatchListStoreModel>(state, sliceKey);

            if (!slice) {
                return {};
            }

            const { filteredMainMarkets } = slice;

            return {
                filteredMainMarket: filteredMainMarkets[mainMarketId],
            };
        },
    ),
    withTranslation<OutcomeListPublicProps>(),
)(OutcomeListComponent);

export default OutcomeList;
